import { Component, OnInit, Input, } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { ICardProductDataModel } from '../../models/card-product.datamodel';

@Component({
  selector: 'app-card-product',
  templateUrl: './card-product.component.html'
})
export class CardProductComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() cardData: ICardProductDataModel;
  data: any;
  constructor() { }

  ngOnInit() {
    // console.log('CardProduct component initialized with component data', this.rendering);
    if (this.cardData) {
      // debugger;
      // this.data = {... this.cardData};
      this.data = {
        Title: this.cardData.Title,
        Description: this.cardData.Description,
        Link: {
          href: this.cardData.Link?.href,
          text: this.cardData.Link?.text || 'Read more',
          linktype: this.cardData.Link?.linktype,
          url: this.cardData.Link?.url,
          anchor: this.cardData.Link?.anchor,
          target: this.cardData.Link?.target
        }
      }
    }
    else {
      this.data = {
        Title: (this.rendering?.fields?.Title as any)?.value,
        Description: (this.rendering?.fields?.Description as any)?.value,
        Link: {
          href: (this.rendering?.fields?.Link as any)?.value?.href,
          text: (this.rendering?.fields?.Link as any)?.value?.text,
          linktype: (this.rendering?.fields?.Link as any)?.value?.linktype,
          url: (this.rendering?.fields?.Link as any)?.value?.url,
          anchor: (this.rendering?.fields?.Link as any)?.value?.anchor,
          target: (this.rendering?.fields?.Link as any)?.value?.target
        }
      };
    }
    // console.log('CardProduct component initialized with data', this.data);
  }
}
